import React from 'react';
import Icon from '../../../components/AppIcon';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const TrendAnalysisWidget = () => {
  const industryGrowthData = [
    { industry: 'IT', growth: 24.5, demand: 342 },
    { industry: 'Finance', growth: 18.2, demand: 245 },
    { industry: 'Healthcare', growth: 21.8, demand: 198 },
    { industry: 'E-commerce', growth: 28.4, demand: 165 },
    { industry: 'Consulting', growth: 15.7, demand: 142 }
  ];

  const placementRateTrends = [
    { metric: 'Overall Rate', current: 87.5, predicted: 89.3, change: '+1.8%' },
    { metric: 'IT Sector', current: 92.1, predicted: 94.2, change: '+2.1%' },
    { metric: 'Finance', current: 85.3, predicted: 87.8, change: '+2.5%' },
    { metric: 'Healthcare', current: 83.7, predicted: 86.1, change: '+2.4%' }
  ];

  return (
    <div className="bg-card rounded-xl p-6 border border-border shadow-warm-sm">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Activity" size={20} color="var(--color-accent)" />
        <h3 className="text-lg font-heading font-semibold text-card-foreground">Trend Analysis</h3>
      </div>

      <div className="space-y-6">
        <div>
          <h4 className="text-sm font-semibold text-card-foreground mb-3">Industry Growth Indicators</h4>
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={industryGrowthData}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
              <XAxis dataKey="industry" stroke="var(--color-muted-foreground)" />
              <YAxis stroke="var(--color-muted-foreground)" />
              <Tooltip 
                contentStyle={{ 
                  backgroundColor: 'var(--color-card)', 
                  border: '1px solid var(--color-border)',
                  borderRadius: '8px'
                }} 
              />
              <Bar dataKey="growth" fill="var(--color-accent)" radius={[8, 8, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-card-foreground mb-3">Placement Rate Predictions</h4>
          <div className="space-y-3">
            {placementRateTrends?.map((trend, idx) => (
              <div key={idx} className="p-3 rounded-lg border border-border hover:border-primary transition-smooth">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-medium text-card-foreground">{trend?.metric}</span>
                  <span className="text-xs font-semibold text-success">{trend?.change}</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="flex-1">
                    <div className="flex items-center justify-between text-xs text-muted-foreground mb-1">
                      <span>Current: {trend?.current}%</span>
                      <span>Predicted: {trend?.predicted}%</span>
                    </div>
                    <div className="h-2 bg-muted rounded-full overflow-hidden">
                      <div className="h-full flex">
                        <div 
                          className="bg-success transition-smooth"
                          style={{ width: `${trend?.current}%` }}
                        />
                        <div 
                          className="bg-primary transition-smooth"
                          style={{ width: `${trend?.predicted - trend?.current}%` }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="p-4 rounded-lg bg-primary/10 border border-primary/20">
          <div className="flex items-start gap-3">
            <Icon name="Sparkles" size={18} color="var(--color-primary)" />
            <div>
              <h4 className="text-sm font-semibold text-primary mb-1">AI Insight</h4>
              <p className="text-xs text-card-foreground">
                E-commerce sector showing strongest growth trajectory with 28.4% increase. 
                Recommend focusing recruitment efforts on this high-demand area.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrendAnalysisWidget;